import { type Transition, zTransition } from "@spz/shared-domain";
import z from "zod";

export function parseTransitions(raw: unknown): Transition[] | null {
  const arrRes = z.array(zTransition).safeParse(raw);
  if (arrRes.success) return arrRes.data;

  return null;
}
